type Plan = "basic" | "active";

export async function startCheckout(params: { email: string; plan: Plan }) {
  localStorage.setItem("niyyah_return_to", "/pricing");
  const url = import.meta.env.VITE_CREATE_CHECKOUT_URL as string;
  if (!url) throw new Error("Missing VITE_CREATE_CHECKOUT_URL");

const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

const res = await fetch(url, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${anon}`,
    "apikey": anon,
  },
  body: JSON.stringify(params),
});

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Failed to create checkout session");
  }

  const json = await res.json();
  if (!json?.url) throw new Error("No checkout url returned");

  // Redirect user to Stripe-hosted Checkout
  window.location.href = json.url;
}
